import json from './sprite.js';

export default {
    handle: 'ENG_SPT10-Soccer_225003020',
    label: 'en_SPT10-Soccer_225003020',
    json,
};
